// Şifreleme anahtarlarının hangi hesaba ait olduğu (9.34.8.3 · D-711).
//
// Aynı cihazda iki hesap açılınca anahtarlar karışıyordu (D-708). Artık her
// hesabın anahtarları kendi önekiyle duruyor (`secureStorage.scopedKey`). Bu
// dosya oturum açan hesabın kapsamını kuruyor ve D-711 öncesinden kalan öneksiz
// anahtarların sahibini buluyor:
//
// - Sahip daha önce kaydedildiyse ona bakılır.
// - Kaydedilmediyse ve öneksiz bir kimlik varsa, dizine sorulur: o kimlik bu
//   hesabın cihazları arasında mı? Öyleyse anahtarlar bu hesabındır; sahip
//   kaydedilir ve hesap öneksiz adları kullanmaya devam eder. Hiçbir şey taşınmaz,
//   hiçbir geçmiş kaybolmaz.
// - Değilse anahtarlar başka bir hesabındır; bu hesap kendi önekiyle başlar.
// - Dizine ulaşılamazsa karar verilmez: bu açılış eskisi gibi öneksiz çalışır,
//   sonraki açılış yeniden sorar. Yanlış karar, ya başkasının anahtarını
//   kullanmak ya da kendi geçmişini bırakıp yeni cihaz olmak demekti.
import { api, ApiError } from '../services/api';
import { getUnscopedSecret, setKeyScope, setUnscopedSecret } from './secureStorage';
import { IDENTITY_PUBLIC } from './storageKeys';

export const LEGACY_OWNER = 'signal.legacyOwner';

export type OwnerDecision = 'owner' | 'other' | 'undecided';

export async function decideLegacyOwner(input: {
  userId: number;
  token: string;
  owner: string | null;
  legacyIdentity: string | null;
  list?: typeof api.fetchDeviceList;
}): Promise<OwnerDecision> {
  if (input.owner !== null) return input.owner === String(input.userId) ? 'owner' : 'other';
  if (!input.legacyIdentity) return 'other';
  const list = input.list ?? api.fetchDeviceList;
  try {
    const devices = (await list(input.token, input.userId)).devices;
    return devices.some((d) => d.identity_key === input.legacyIdentity) ? 'owner' : 'other';
  } catch (error) {
    return error instanceof ApiError && error.status === 404 ? 'other' : 'undecided';
  }
}

let istenen: number | null = null;

/**
 * Oturum açan hesabın anahtar kapsamını kur. Oturum belirlenir belirlenmez,
 * ekranlar şifreleme işine başlamadan çağrılır; okuma ve yazmalar karar
 * verilene kadar bekler. Aynı hesap için tekrar çağrılırsa bir şey yapmaz.
 */
export function beginE2eeAccount(token: string, userId: number): Promise<void> {
  if (!token || !userId) return Promise.resolve();
  if (istenen === userId) return Promise.resolve();
  istenen = userId;
  return setKeyScope((async () => {
    const owner = await getUnscopedSecret(LEGACY_OWNER);
    const legacyIdentity = await getUnscopedSecret(IDENTITY_PUBLIC);
    const decision = await decideLegacyOwner({ userId, token, owner, legacyIdentity });
    if (decision === 'owner' && owner === null) await setUnscopedSecret(LEGACY_OWNER, String(userId));
    // Karar verilemediyse bu açılış eskisi gibi: öneksiz.
    return { hesap: userId, eskiSahibi: decision !== 'other' };
  })());
}

/** Çıkışta kapsamı kaldır. Anahtarlar silinmez; aynı hesap dönünce yerindedir. */
export function endE2eeAccount(): void {
  istenen = null;
  void setKeyScope(Promise.resolve({ hesap: null, eskiSahibi: false }));
}
